import { avatarPaletteIndex, initialsOf } from '../../lib/colors';
import styles from './Avatar.module.css';

interface AvatarProps {
  name: string;
  size?: 'sm' | 'md';
}

export function Avatar({ name, size = 'sm' }: AvatarProps): React.JSX.Element {
  const index = avatarPaletteIndex(name);
  return (
    <span
      className={`${styles.avatar} ${styles[size]}`}
      style={{
        background: `var(--avatar-${String(index)}-bg)`,
        color: `var(--avatar-${String(index)}-ink)`,
      }}
      title={name}
      aria-hidden="true"
    >
      {initialsOf(name)}
    </span>
  );
}
